import type { BN } from "@coral-xyz/anchor";
import { AnchorProvider, Program } from "@coral-xyz/anchor";
import type { Connection } from "@solana/web3.js";
import { PublicKey } from "@solana/web3.js";
import Decimal from "decimal.js";
import type { Vault } from "hedge-web3";
import { IDL } from "hedge-web3";

import type { Wallet } from "../../types/wallet";

export const HEDGE_PROGRAM_ID = "HedgeEohwU6RqokrvPU4Hb6XKPub8NuKbnPmY7FoMMtN";
export const HEDGE_PROGRAM_PUBLICKEY = new PublicKey(HEDGE_PROGRAM_ID);
export const USH_MINT = "9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6";
export const HDG_MINT = "5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy";
const WAD = new Decimal("1000000000000000000");

export type HedgeProgram = Program<Vault>;

export function HedgeProgram(connection: Connection, wallet: Wallet): HedgeProgram {
  const provider = new AnchorProvider(connection, wallet, {
    skipPreflight: false,
    commitment: "confirmed",
    preflightCommitment: "confirmed",
  });
  return new Program<Vault>(IDL, HEDGE_PROGRAM_PUBLICKEY, provider);
}

export const u128ToDecimal = (input: number | string | BN): Decimal => {
  return new Decimal(input.toString()).div(WAD);
};

export const hedgeRewardsDecay = (
  supply: number,
  birthTime: number,
  timeIn: number,
  timeOut: number,
  halfLifeInDays: number,
): number => {
  const timeInOffsetStart = timeIn - birthTime;
  const timeOutOffsetStart = timeOut - birthTime;
  const halfLife = (-1 * Math.log(2)) / (halfLifeInDays * 60 * 60 * 24);
  const awardedTokens =
    supply * (Math.pow(Math.E, halfLife * timeInOffsetStart) - Math.pow(Math.E, halfLife * timeOutOffsetStart));
  return awardedTokens;
};
